import { advanceQuoteDaysStates } from '@ourbranch/lookups';

export const offerUsesAdvanceQuoteDays = (state, policyType) => {
  if (!state || !policyType) {
    return false;
  }

  const adqState = advanceQuoteDaysStates[state];
  if (!adqState) {
    return false;
  }

  const policyTypes = policyType.split('');
  return policyTypes.some((type) => adqState[type] === true);
};

// Returns true if the state is in the AQD lookup at all, regardless of policy type.
// Used to suppress FED messaging/discount for all policy types in AQD states.
export const stateHasAdvanceQuoteDays = (state) => {
  return !!advanceQuoteDaysStates[state];
};
